<template>
  <div class="m524-bottom-drawer" :style="bottomDrawerStyle" @click.stop="">
    <div style="text-align:center;">
      <span
        class="m524-drawer-handle"
        @mouseup.stop=""
        @mousedown.stop="clickHandle"
        @touchstart.stop="clickHandle"
        @touchend.stop=""
      >
        <img :src="img.handle" alt="" />
      </span>
    </div>
    <div class="m524-drawer-crown" v-if="show">
      <img :src="img.crown" alt="">
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: Number,
      required: true
    },
    expendHeight: {
      type: Number,
      required: true
    },
    bottom: {
      type: Number,
      default: 0
    },
    left: {
      type: Number,
      default: 0
    },
    // show / hide
    show: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    screen () {
      const { height, width } = this.$store.state.screen
      return {
        height: height - 1,
        width
      }
    },
    componentRect () {
      const bottom = this.bottom
      const left = this.left
      const height = this.show ? this.expendHeight : this.height
      return {
        bottom,
        left,
        height
      }
    },
    bottomDrawerStyle () {
      const { bottom, left, height } = this.componentRect
      return {
        bottom: bottom + 'px',
        left: left + 'px',
        height: height + 'px',
        width: '100%'
      }
    }
  },
  data () {
    return {
      img: {
        handle: require('@/assets/mind524/img/b-drawer-handle.png'),
        crown: require('@/assets/mind524/img/b-drawer-crown.png')
      }
    }
  },
  methods: {
    clickHandle (e) {
      if (this.show) {
        this.close()
      } else {
        this.open()
      }
    },
    open () {
      this.$emit('update:show', true)
      this.$emit('open')
    },
    close () {
      this.$emit('update:show', false)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  .m524-bottom-drawer{
    position: absolute;
    border-radius: 15px;
    overflow: hidden;
    background-color: rgb(255, 255, 255);
    z-index: 1000;
    box-shadow: 0px -5px 10px #0002;
  }
  .m524-drawer-handle{
    padding: 8px;
    cursor: pointer;
    &:hover{
      opacity: 0.7;
    }
  }
  .m524-drawer-crown{
    position: absolute;
    top: 5px;
    left: calc(50% - 105px);
  }
</style>
